/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Messaging_Bots_Broadcast_Title9Inputs */

const en_svc_messaging_bots_broadcast_title9 = /** @type {(inputs: Svc_Messaging_Bots_Broadcast_Title9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broadcasts and templates`)
};

const ar_svc_messaging_bots_broadcast_title9 = /** @type {(inputs: Svc_Messaging_Bots_Broadcast_Title9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البث والقوالب`)
};

const bn_svc_messaging_bots_broadcast_title9 = /** @type {(inputs: Svc_Messaging_Bots_Broadcast_Title9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ব্রডকাস্ট ও টেমপ্লেট`)
};

const de_svc_messaging_bots_broadcast_title9 = /** @type {(inputs: Svc_Messaging_Bots_Broadcast_Title9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broadcasts und Vorlagen`)
};

const es_svc_messaging_bots_broadcast_title9 = /** @type {(inputs: Svc_Messaging_Bots_Broadcast_Title9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Difusiones y plantillas`)
};

const fr_svc_messaging_bots_broadcast_title9 = /** @type {(inputs: Svc_Messaging_Bots_Broadcast_Title9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diffusions et modèles`)
};

const pt_svc_messaging_bots_broadcast_title9 = /** @type {(inputs: Svc_Messaging_Bots_Broadcast_Title9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Difusões e modelos`)
};

const zh_svc_messaging_bots_broadcast_title9 = /** @type {(inputs: Svc_Messaging_Bots_Broadcast_Title9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`群发与模板`)
};

const tr_svc_messaging_bots_broadcast_title9 = /** @type {(inputs: Svc_Messaging_Bots_Broadcast_Title9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toplu mesajlar ve şablonlar`)
};

const ru_svc_messaging_bots_broadcast_title9 = /** @type {(inputs: Svc_Messaging_Bots_Broadcast_Title9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рассылки и шаблоны`)
};

const pl_svc_messaging_bots_broadcast_title9 = /** @type {(inputs: Svc_Messaging_Bots_Broadcast_Title9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozsyłki i szablony`)
};

/**
* | output |
* | --- |
* | "Broadcasts and templates" |
*
* @param {Svc_Messaging_Bots_Broadcast_Title9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_messaging_bots_broadcast_title9 = /** @type {((inputs?: Svc_Messaging_Bots_Broadcast_Title9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Messaging_Bots_Broadcast_Title9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_messaging_bots_broadcast_title9(inputs)
	if (locale === "bn") return bn_svc_messaging_bots_broadcast_title9(inputs)
	if (locale === "de") return de_svc_messaging_bots_broadcast_title9(inputs)
	if (locale === "es") return es_svc_messaging_bots_broadcast_title9(inputs)
	if (locale === "fr") return fr_svc_messaging_bots_broadcast_title9(inputs)
	if (locale === "pt") return pt_svc_messaging_bots_broadcast_title9(inputs)
	if (locale === "zh") return zh_svc_messaging_bots_broadcast_title9(inputs)
	if (locale === "tr") return tr_svc_messaging_bots_broadcast_title9(inputs)
	if (locale === "ru") return ru_svc_messaging_bots_broadcast_title9(inputs)
	if (locale === "pl") return pl_svc_messaging_bots_broadcast_title9(inputs)
	return en_svc_messaging_bots_broadcast_title9(inputs)
});
export { svc_messaging_bots_broadcast_title9 as "svc_messaging-bots_BROADCAST_title" }